import * as ambassadorWixRestaurantsMenusV1ItemVariant from './restaurants-menus-v1-item-variant-item-variants.http.js';
import * as ambassadorWixRestaurantsMenusV1ItemVariantTypes from './restaurants-menus-v1-item-variant-item-variants.types.js';
import * as ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes from './restaurants-menus-v1-item-variant-item-variants.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createVariant(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.CreateVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.CreateVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.CreateVariantResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.CreateVariantResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.createVariant(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/variants',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getVariant(): __PublicMethodMetaInfo<
  'GET',
  { variantId: string },
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.GetVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.GetVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.GetVariantResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.GetVariantResponse
> {
  const payload = { variantId: ':variantId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.getVariant(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/variants/{variantId}',
    pathParams: { variantId: 'variantId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listVariants(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.ListVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.ListVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.ListVariantsResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.ListVariantsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.listVariants(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/variants',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateVariant(): __PublicMethodMetaInfo<
  'PATCH',
  { variantId: string },
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.UpdateVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.UpdateVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.UpdateVariantResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.UpdateVariantResponse
> {
  const payload = { variant: { id: ':variantId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.updateVariant(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/variants/{variant.id}',
    pathParams: { variantId: 'variantId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateVariants(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.BulkCreateVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.BulkCreateVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.BulkCreateVariantsResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.BulkCreateVariantsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.bulkCreateVariants(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/variants/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateVariants(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.BulkUpdateVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.BulkUpdateVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.BulkUpdateVariantsResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.BulkUpdateVariantsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.bulkUpdateVariants(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/variants/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteVariant(): __PublicMethodMetaInfo<
  'DELETE',
  { variantId: string },
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.DeleteVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.DeleteVariantRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.DeleteVariantResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.DeleteVariantResponse
> {
  const payload = { variantId: ':variantId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.deleteVariant(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/variants/{variantId}',
    pathParams: { variantId: 'variantId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryVariants(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.QueryVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.QueryVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.QueryVariantsResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.QueryVariantsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.queryVariants(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/variants/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countVariants(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.CountVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.CountVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.CountVariantsResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.CountVariantsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.countVariants(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/variants/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteVariants(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.BulkDeleteVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.BulkDeleteVariantsRequest,
  ambassadorWixRestaurantsMenusV1ItemVariantUniversalTypes.BulkDeleteVariantsResponse,
  ambassadorWixRestaurantsMenusV1ItemVariantTypes.BulkDeleteVariantsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemVariant.bulkDeleteVariants(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/variants/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Variant as VariantOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ExternalReferenceInfo as ExternalReferenceInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateVariantRequest as CreateVariantRequestOriginal,
  CreateVariantResponse as CreateVariantResponseOriginal,
  GetVariantRequest as GetVariantRequestOriginal,
  GetVariantResponse as GetVariantResponseOriginal,
  ListVariantsRequest as ListVariantsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListVariantsResponse as ListVariantsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateVariantRequest as UpdateVariantRequestOriginal,
  UpdateVariantResponse as UpdateVariantResponseOriginal,
  BulkCreateVariantsRequest as BulkCreateVariantsRequestOriginal,
  BulkCreateVariantsResponse as BulkCreateVariantsResponseOriginal,
  BulkVariantResult as BulkVariantResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateVariantsRequest as BulkUpdateVariantsRequestOriginal,
  MaskedVariant as MaskedVariantOriginal,
  BulkUpdateVariantsResponse as BulkUpdateVariantsResponseOriginal,
  DeleteVariantRequest as DeleteVariantRequestOriginal,
  DeleteVariantResponse as DeleteVariantResponseOriginal,
  QueryVariantsRequest as QueryVariantsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryVariantsResponse as QueryVariantsResponseOriginal,
  CountVariantsRequest as CountVariantsRequestOriginal,
  CountVariantsResponse as CountVariantsResponseOriginal,
  CloneVariantsRequest as CloneVariantsRequestOriginal,
  CloneVariantsResponse as CloneVariantsResponseOriginal,
  BulkDeleteVariantsRequest as BulkDeleteVariantsRequestOriginal,
  BulkDeleteVariantsResponse as BulkDeleteVariantsResponseOriginal,
  BulkDeleteVariantsResult as BulkDeleteVariantsResultOriginal,
  BulkUpdateBusinessLocationIdsRequest as BulkUpdateBusinessLocationIdsRequestOriginal,
  BulkUpdateBusinessLocationIdsResponse as BulkUpdateBusinessLocationIdsResponseOriginal,
  BulkUpdateBusinessLocationIdsResponseBulkItemResult as BulkUpdateBusinessLocationIdsResponseBulkItemResultOriginal,
  BulkUpdateBusinessLocationIdsPerEntityRequest as BulkUpdateBusinessLocationIdsPerEntityRequestOriginal,
  VariantIdLocationIds as VariantIdLocationIdsOriginal,
  BulkUpdateBusinessLocationIdsPerEntityResponse as BulkUpdateBusinessLocationIdsPerEntityResponseOriginal,
  BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult as BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResultOriginal,
  BulkUpdateAttachedToOrphanItemRequest as BulkUpdateAttachedToOrphanItemRequestOriginal,
  VariantIdAttachedToOrphanItem as VariantIdAttachedToOrphanItemOriginal,
  BulkUpdateAttachedToOrphanItemResponse as BulkUpdateAttachedToOrphanItemResponseOriginal,
  BulkItemResult as BulkItemResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  SyncContentToMultilingualRequest as SyncContentToMultilingualRequestOriginal,
  SyncContentToMultilingualResponse as SyncContentToMultilingualResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CountVariantsApplicationErrors as CountVariantsApplicationErrorsOriginal,
} from './restaurants-menus-v1-item-variant-item-variants.types.js';
